import { StoreSkuItem } from "@playroomkit/pr-wars-data";
import View from "@components/View";
import { images } from "@utils/media";

interface BundleGridItemProps extends StoreSkuItem {
  onClick: (sku_id: string) => void;
  showPrice: (price: string | number) => string;
}

export const BundleGridItem = (props: BundleGridItemProps) => {
  //   const { sku_id, price, onClick, purchased, metadata, showPrice } = props;

  return (
    <View className="col-span-4 w-full h-full">
      <img
        src={images.BundlePlaceholder}
        alt="bundle"
        className="w-full h-full object-contain"
      />
    </View>
  );
};
